import React from 'react'
import { Link } from 'react-router-dom';
import style from '../../css/About.module.css'

function AboutTop() {
	return (
		<div>
			<div className={style.container}>
				<div className={style.container1}>
					<p className={style.txt}>About Us</p>
					<p className={style.txt1}>With our knowledge we guarente success</p>
					<p className={style.txt2}>
						At Kanasu Educational and Charitable Trust, we are committed to
						transforming lives through education and charitable initiatives. Our
						mission is to provide quality education, support underprivileged
						individuals, and create a nurturing environment that fosters growth
						and development. We firmly believe that education is the foundation
						of personal and societal growth, and we strive to bridge the gap
						between privilege and opportunity.
					</p>
					<div className={style.row}>

					<Link to={'/Course'} className={style.link}>
						Our Courses
					</Link>
					<Link to={'/Service'} className={style.link}>
						Our Services
					</Link>
					</div>
				</div>
				<img
					src="https://www.vidyard.com/wp-content/themes/vidyard-website/img/pages/company/about-us/main-image.png.webp"
					alt="Image"
					className={style.image}
				/>
			</div>
		</div>
	);
}

export default AboutTop